module.exports = new __parcel__URL__("Angie.ce60f296.svg").toString();